'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormElement = require('./FormElement');

var _FormElement2 = _interopRequireDefault(_FormElement);

var _Notification = require('./Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _utils = require('../utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormValidator = function () {
  function FormValidator(_ref) {
    var selector = _ref.selector,
        form = _ref.form,
        _ref$fields = _ref.fields,
        fields = _ref$fields === undefined ? {} : _ref$fields,
        _ref$onSubmit = _ref.onSubmit,
        onSubmit = _ref$onSubmit === undefined ? _utils.noop : _ref$onSubmit;

    _classCallCheck(this, FormValidator);

    this.selector = selector;
    this.form = form;
    this.fields = fields;
    this.onSubmit = onSubmit;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitSuccessCallback = this.submitSuccessCallback.bind(this);
    this.submitErrorCallback = this.submitErrorCallback.bind(this);
  }

  _createClass(FormValidator, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.form = this.form || this.selector && document.querySelector(this.selector);

      if (!(0, _utils.isDOMNode)(this.form)) {
        throw new Error('Form is not a DOM node');
      }

      this.notification = new _Notification2.default({ container: this.form });

      this.fields = Object.keys(this.fields).reduce(function (acc, key) {
        var formElement = new _FormElement2.default(_extends({}, _this.fields[key], { id: key }));
        formElement.init();
        return _extends({}, acc, _defineProperty({}, key, formElement));
      }, {});

      // Adding the reference back to all the form fields for each field
      Object.keys(this.fields).forEach(function (key) {
        return _this.fields[key].formFields = _this.fields;
      });

      this.form.addEventListener('submit', this.handleSubmit);

      this.valid = true;
      this.touched = false;
      this.submitted = false;
    }
  }, {
    key: 'submitSuccessCallback',
    value: function submitSuccessCallback() {}
  }, {
    key: 'submitErrorCallback',
    value: function submitErrorCallback(data) {
      var _this2 = this;

      // rate limited
      if ((0, _utils.isObject)(data) && typeof data.status !== 'undefined' && data.status === 429) {
        this.notification.showError('RATE_LIMITED', "You've made too many attempts at this request. Please try this action again in a few minutes.");
      } else {
        (Array.isArray(data) && data || (0, _utils.isObject)(data) && [data] || []).forEach(function (_ref2) {
          var errorType = _ref2.errorType,
              field = _ref2.field,
              translatedMessage = _ref2.translatedMessage;

          // Show the notification on the field element
          var element = _this2.fields[field];
          if (element && (0, _utils.isFunction)(element.error) && !(0, _utils.isHidden)(element)) {
            element.stickyError(translatedMessage);
          } else {
            // Show the notification on top
            _this2.notification.showError(errorType, translatedMessage);
          }
        });
      }
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();

      this.notification.hide();

      this.resetValidation();
      if (!this.validate()) {
        return;
      }

      this.submitted = true;
      this.onSubmit(this.fields, this.submitSuccessCallback, this.submitErrorCallback);
    }
  }, {
    key: 'validate',
    value: function validate() {
      var _this3 = this;

      this.valid = Object.keys(this.fields).reduce(function (acc, key) {
        return _this3.fields[key].validate(true) && acc;
      }, true);
      return this.valid;
    }
  }, {
    key: 'resetValidation',
    value: function resetValidation() {
      var _this4 = this;

      this.valid = true;
      this.touched = false;
      this.submitted = false;

      Object.keys(this.fields).forEach(function (key) {
        return _this4.fields[key].resetValidation();
      });
      Object.keys(this.fields).forEach(function (key) {
        return _this4.fields[key].removeStickyError();
      });
    }
  }]);

  return FormValidator;
}();

exports.default = FormValidator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/validation/FormValidator.js
// module id = 4
// module chunks = 0 1 2 3